import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import LicenceTypeAdminService from "../services/LicenceTypeAdminService";

const useLicenceTypeAdminService = () => {
  const { client } = useApiContext();
  const service = useMemo(() => {
    return new LicenceTypeAdminService(client);
  }, [client]);

  return service;
};

export default useLicenceTypeAdminService;
